import { useState, useEffect } from "react";
import axios from "../api/apiClient";
import { token, domain } from '../components/Security';


let cachedUser = undefined;  
// undefined → not fetched yet
// null → fetched but failed
// object → fetched successfully

export default function useUser() {
  const [user, setUser] = useState(cachedUser ?? null);

  useEffect(() => {
    // If already fetched (success or fail), reuse instantly
    if (cachedUser !== undefined) {
      setUser(cachedUser);
      return;
    }

    const fetchUser = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (!storedUser) {
          cachedUser = null;
          setUser(null);
          return;
        }

        const employeeId = storedUser.employeePersonalInformationId;

        const response = await axios.get(
          `${domain}/api/Employee/${employeeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = response.data;

        const userData = {
          id: data.id,
          employeeId: data.employeeId,
          fullName: data.fullName,
          position: data.employeeInformation?.positionDescription || null,
        };

        cachedUser = userData;
        setUser(userData);
      } catch (err) {
        console.error("❌ useUser(): error fetching user → returning null", err);
        cachedUser = null;
        setUser(null);
      }
    };

    fetchUser();
  }, []);

  return user;
}
